export const VENDOR_FIELDS_TYPE = 'vendor';
export const CUSTOM_FIELDS_TYPE = 'custom';

export interface VendorFieldsGroup {
    name: string;
    options: {
        label: string;
        value: string;
    }[];
    category: string;
}
